import { adminAiGenerationQueryKeys as e } from "./adminAiGenerationQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { adminAiApi as n } from "@maat/api-ai";
//#region src/ai/admin/useAdminAiGenerationsSummaryQuery.ts
var r = (r) => t({
	queryKey: e.summary(r),
	queryFn: () => n.getGenerationsSummary(r)
});
//#endregion
export { r as useAdminAiGenerationsSummaryQuery };
